import React, { useEffect, useState, useContext } from 'react';
import { message, Form, Row } from 'antd';
import { v4 as uuidv4 } from 'uuid';

import { CommonCloudFirestore } from '../../services/CommonCloudFirestore';
import commonCloudStorage from '../../services/CommonCloudStorage';

import global from '../../../shared/utility/global';
import { 
    DOCUMENT_CONFIGURATION, 
    LISTENER_CONFIGURATIONS,
    CONFIGURATION_COMPANY
 } from '../../../shared/types/firestoreType';
import { ModalContext } from '../../../shared/context/ModalContext';

import Loading from '../../../shared/components/Loading/Index';
import Header from './Header';
import MainInformation from './MainInformation';
import SocialNetworks from './SocialNetworks';

export default function Index(_) {
    const modal = useContext(ModalContext);
    const configurationsFirestore = new CommonCloudFirestore(DOCUMENT_CONFIGURATION);

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(undefined);
    const [id, setId] = useState(CONFIGURATION_COMPANY);

    useEffect(() => {
        form.setFieldsValue({
            businessName: '',
            description: '',
            phone: '',
            email: '',
            location: '',
            whatsapp: '',
            facebook: '',
            instagram: '',
            youtube: '',
            twitter: '',
        });
        onLoad();
    }, []);

    const onLoad = async () => {
        setLoading(true);
        
        var response = await configurationsFirestore.getDocumentById(id);

        form.setFieldsValue(response);
        if (response?.imageUrl)
            setFile({ url: response?.imageUrl });

        setLoading(false);
    };

    const onSave = async () => {
        var validations = await form.validateFields().then(() => true).catch(() => false);
        if (!validations) {
            message.warning('Por favor completa los datos del formulario.', 7);
            return;
        }

        if (file === undefined) {
            message.warning('Por favor agregue su logo.', 7);
            return;
        }

        modal.confirm("¿Esta seguro de realizar la acción?", async () => {
            setLoading(true);

            if (!file.url) {
                var imageUrl = await commonCloudStorage.uploadFromStringBase64(file.stringBase64, `${DOCUMENT_CONFIGURATION}/` + file.storageFilename);
                if (!imageUrl) {
                    message.error('Ocurrió un error al subir la imagen, por favor vuelva a intentarlo.', 7);
                    return;
                }
            }

            var documentData = form.getFieldsValue();
            documentData.imageUrl = !file.url ? imageUrl : file.url;

            var response = false;
            var findDocument = await configurationsFirestore.getDocumentById(id);
            
            if (!findDocument)
                response = await configurationsFirestore.addDocument(id, documentData, [LISTENER_CONFIGURATIONS]);
            else
                response = await configurationsFirestore.upateDocument(id, documentData, [LISTENER_CONFIGURATIONS]);
  
            if (response)
                message.success(`Datos guardados correctamente.`, 6);
            else
                message.error('Ocurrió un error inesperado.', 6);

            setLoading(false);
        });
    };

    const onBefore = async (file) => {
        const allowedExtensions = ["image/png", "image/jpg", "image/jpeg", "image/gif", "image/tiff", "image/svg+xml", "image/webp"];
        const allowedExtensionsValid = allowedExtensions.includes(file.type);

        if (!allowedExtensionsValid) {
            message.error(`${file.name} no es una imagen valida.`, 7);
            return;
        }

        file.stringBase64 = await global.getBase64(file);
        file.storageFilename = uuidv4() + '.' + file.name.split('.')[file.name.split('.').length - 1];
        setFile(file);
    };

    return (
        <Row justify={'center'}>

            <div className='w-100' style={{ maxWidth: 570 }}>
                <Loading visible={loading} text="cargando">
                    <Form
                        form={form}
                        layout="vertical"
                    >
                        <Header
                            onSave={onSave}
                        />
                        <MainInformation
                            file={file}
                            onBefore={onBefore}
                        />
                        <SocialNetworks
                            file={file}
                        />
                    </Form>
                </Loading>
            </div>
        </Row>
    )
}